import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = ["data-kt-indicator"]
const _hoisted_5 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_6 = { class: "indicator-progress" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      style: {"width":"1000px !important"},
      class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto",
      innerHTML: _ctx.inner
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          "data-kt-indicator": _ctx.loading ? 'on' : null,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.connect && _ctx.connect(...args))),
          class: "btn btn-primary my-3 float-end"
        }, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Accept"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_4)
      ])
    ])
  ]))
}